package com.fireavert.auth.user_authentication.data_models.requests

data class AuthenticateRequest(val email: String, val password: String)